import Model from '@ember-data/model';

export default class MembershipPurchaseModel extends Model {
  // This is just needed for polymorphic relationship (source) to work
}
